export default __webpack_public_path__ + "static/media/Img-2.6488012a.png";